import React, { useState } from 'react';
import '../../../entrydoor.css';

const FrameSize = ({ value, onChange, label = 'Frame size:', disabled = false, passSelectedDoor }) => {
    const [selectedFrameSize, setSelectedFrameSize] = useState(value || "5");

    const handleFrameSizeChange = (e) => {
        setSelectedFrameSize(e.target.value);
        onChange(e.target.value);
    };

    if (passSelectedDoor && passSelectedDoor.id < 5) {
        return null; // component disappears from the DOM
    }

    return (
        <div className="a-container">
            <label disabled={disabled} htmlFor="FrameSize">{label}</label>
            <select
                disabled={disabled}
                id="FrameSizeCustom"
                value={selectedFrameSize}
                onChange={handleFrameSizeChange}
            >
                <option value="" disabled hidden>Select an option</option>
                <option value="5">{selectedFrameSize === "5" ? "5' ✔" : "5'"}</option>
                <option value="6">{selectedFrameSize === "6" ? "6' ✔" : "6'"}</option>
                <option value="Custom">{selectedFrameSize === "Custom" ? "Custom ✔" : "Custom"}</option>
           </select>
        </div>
    );
};

export default FrameSize;
